import i18n from 'i18next';

export const getFormattedPurchasePrice = (product) => {
  const formatter = new Intl.NumberFormat(i18n.language, {
    style: 'currency',
    currency: product.purchase.currency.toUpperCase(),
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return formatter.format(product.purchase.price);
};

/**
 * An amount with its cents always spelled out, in the currency it was quoted in. Taxes and
 * totals are shown this way whatever the price above them looks like.
 *
 * @param {number} amount major units
 * @param {string} currency
 * @returns {string}
 */
export const getFormattedAmount = (amount, currency) => {
  const formatter = new Intl.NumberFormat(i18n.language, {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(amount);
};

export const getFormattedPurchasePriceWithTax = (product, expectedTotal) => (
  getFormattedAmount(expectedTotal, product.purchase.currency)
);

export const getFormattedCurrency = (currency, defaultCurrency) => {
  if (currency === 'RBY') {
    return 'Rubies'; // todo: hot fix for ECON-3198
  }
  return defaultCurrency || currency;
};

export const getFormattedExchangePrice = (product) => {
  const formatter = new Intl.NumberFormat(i18n.language, {
    style: 'currency',
    currency: product.exchange.currency.toUpperCase(),
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return formatter.format(product.exchange.price);
};

export const getProductFormattedNumber = (amount) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return formatter.format(amount);
};

export const getFormattedPrice = (price, currency) => {
  const formatter = new Intl.NumberFormat(i18n.language, {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return formatter.format(price);
};
